import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxInnerLoadingModule } from 'ngx-inner-loading';

import { PeriodBarModule } from '../../../../../../../components/period-bar/period-bar.module';
import { BillRowModule } from '../../../../components/bill-row/bill-row.module';
import { BillsComponent } from './bills.component';

@NgModule({
  declarations: [BillsComponent],
  imports: [
    CommonModule,
    BillRowModule,
    BsDropdownModule,
    InfiniteScrollModule,
    NgxBootstrapIconsModule,
    NgxInnerLoadingModule,
    PeriodBarModule,
  ],
})
export class BillsModule {}
